import React from 'react';
import { Alert, AlertTitle } from '@mui/material';

export const AlertDialogContainer = props => {
  const { severity, title, message, setShowAlert } = props;

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setShowAlert(false);
    }, 4000);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <Alert
      severity={severity}
      style={{
        position: 'fixed',
        right: '3%',
        bottom: '9%',
        zIndex: 999,
        minWidth: 300,
        maxWidth: 400,
        opacity: '0.9',
        marginLeft: 'auto'
      }}
    >
      <AlertTitle>{title}</AlertTitle>
      {message}
    </Alert>
  );
};
